import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { appPath } from '../../../../constants';

class ListItem extends Component {
  handleClick = () => {
    const { link, history, onClick } = this.props;

    if (link) {
      return history.push(`/${appPath}/${link}`);
    }

    if (_.isFunction(onClick)) {
      onClick();
    }
  };

  render () {
    return (
      <div className={this.props.className}>
        <div className={`list-item d-sm-flex flex-wrap align-items-center`} onClick={this.handleClick}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withRouter(ListItem);

ListItem.propTypes = {
  link: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/lists/ListItem/index.js